import { isMobile, getPara, checkBrowserVersion } from "@/assets/js/tool.js";
import Header from "@/components/Header";
import { ref } from "vue";
import { ElMessageBox } from "element-plus";
export default {
  components: {
    Header
  },
  setup() {
    if (isMobile()) {
      window.location.replace(window.location.href.replace(/student/g, "student/m"));
    }
    let showHeader = ref(1);
    let ifHeader = ref(0);
    if (window.location.hash.indexOf("preview") != -1) {
      showHeader.value = false;
    }
    if (getPara("appKey")) {
      ifHeader.value = false;
    }
    //浏览器检查

    if (!checkBrowserVersion()) {
      ElMessageBox.alert("你的浏览器版本无法满足测试要求，请及时更换浏览器再进行测试。<a href='https://www.google.cn/chrome/'>谷歌浏览器</a>、<a href='https://www.microsoft.com/zh-cn/edge/welcome'>edge浏览器</a>、<a>谷歌绿色解压版</a>", "提示", {
        dangerouslyUseHTMLString: true
      });
    }
    return {
      showHeader,
      ifHeader
    };
  }
};